export default __webpack_public_path__ + "static/media/beeswax-icon2.327ccd6c.svg";